export class SortedGroup {
  letter: string;
  elements: Array<any>;

  constructor(letter: string, elements: Array<any>) {
    this.letter = letter;
    this.elements = elements;
  }
}
